import { IsObject } from '../../../helpers';
import { NOTIFICATIONS_OBSERVER_PRIVATE } from './privates';
import { ConstructClassWithPrivateMembers } from '../../../misc/helpers/ClassWithPrivateMembers';
export function ConstructNotificationsObserver(instance, name, callback) {
    ConstructClassWithPrivateMembers(instance, NOTIFICATIONS_OBSERVER_PRIVATE);
    const privates = instance[NOTIFICATIONS_OBSERVER_PRIVATE];
    privates.name = name;
    privates.callback = callback.bind(instance);
}
export function IsNotificationsObserver(value) {
    return IsObject(value)
        && value.hasOwnProperty(NOTIFICATIONS_OBSERVER_PRIVATE);
}
//# sourceMappingURL=constructor.js.map